/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect } from 'react';

import {
  createContract,
  deleteContract,
  getContracts,
  updateContract,
} from '../graphql';

export default () => {
  const [getfins, finData] = useLazyQuery(getContracts);

  const [addContract] = useMutation(createContract, {
    refetchQueries: [{ query: getContracts }],
  });
  const [editContract] = useMutation(updateContract, {
    refetchQueries: [{ query: getContracts }],
  });
  const [removeContract] = useMutation(deleteContract, {
    refetchQueries: [{ query: getContracts }],
  });

  useEffect(() => {
    getfins();
  }, [getfins]);

  const contracts = finData?.data?.['getContracts']?.data || [];
  const refreshcontracts = () => finData?.refetch();

  return {
    contracts,
    addContract,
    editContract,
    removeContract,
    refreshcontracts,
  };
};
